 <template >
  <el-form ref="commonForm" :model="commonForm" :rules="commonRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          v-if="!(code.type == 3 || code.type == 4 || code.type == 5)"
          prop="uniqueNumber"
          label="系统唯一标识"
        >
          <el-input
            v-model="commonForm.uniqueNumber"
            placeholder="选择机构后自动生成，可修改"
            v-if="!isDetail()"
          ></el-input>
          <span v-else>{{ $attrs.detailForm.uniqueNumber }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item prop="deviceBrand" label="设备品牌">
          <el-select
            v-model="commonForm.deviceBrand"
            style="width: 100%"
            @change="brandChange"
            placeholder="请选择"
            v-if="!isDetail()"
          >
            <el-option
              v-for="item in deviceBrandList"
              :key="item.id"
              :label="item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
          <span v-else>{{ $attrs.detailForm.deviceTypeName }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="commonForm.deviceBrand">
      <el-col :span="24">
        <el-form-item prop="agreement" label="关联协议">
          <el-checkbox-group v-if="!isDetail()" :value="commonForm.agreement">
            <el-checkbox
              v-for="item in agreementList"
              :key="item.id"
              :label="item.id"
              @change="agreementChange(item)"
            >
              {{ item.agreementName }}
              <span>{{
                commonForm.versionChoosed[item.id]
                  ? `（${commonForm.versionChoosed[item.id].name}）`
                  : ''
              }}</span>
              <el-button
                v-if="isChoosed(item.id)"
                type="text"
                @click="seeServeDetail(item.id)"
                class="agreement-btn"
                >查看</el-button
              >
            </el-checkbox>
          </el-checkbox-group>
          <div v-else>
            <span v-for="item in historyAgreementList" :key="item.id">
              {{ item.agreementName }}
              <span>
                {{
                  commonForm.versionChoosed[item.id]
                    ? `（${commonForm.versionChoosed[item.id].name}）`
                    : ''
                }}
              </span>
              <el-button
                v-if="isChoosed(item.id)"
                type="text"
                @click="seeServeDetail(item.id)"
                class="agreement-btn"
              >
                查看
              </el-button>
            </span>
            <span v-if="!historyAgreementList.length">{{ '-' }}</span>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item prop="deviceSeries" label="设备系列">
          <el-select
            v-model="commonForm.deviceSeries"
            @change="seriesChange"
            style="width: 100%"
            placeholder="请选择"
            v-if="!isDetail()"
          >
            <el-option
              v-for="item in seriesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span v-else>{{ $attrs.detailForm.deviceSeriesName || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-if="commonForm.deviceSeries">
      <el-col :span="24">
        <el-form-item prop="parameter" label="功能参数">
          <el-checkbox-group v-if="!isDetail()" v-model="commonForm.parameter">
            <el-checkbox v-for="item in parameterList" :key="item.id" :label="item.id">
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
          <span v-else
            >{{
              ($attrs.detailForm.deviceFunctionList &&
                $attrs.detailForm.deviceFunctionList.map(item => item.functionName).join('、')) ||
              '-'
            }}
          </span>
        </el-form-item>
      </el-col>
    </el-row>
    <DealChoose ref="dealChoose" :versionList="versionList" @back="versionChooseBack" />
    <DealDetail ref="dealDetail" />
  </el-form>
</template>
<script>
import { isEmpty, find, filter, cloneDeep } from 'lodash';
import deviceParameterApi from 'api/home/device-mangement/device-parameter';
import deviceBrandApi from 'api/home/device-mangement/device-brand';
import dealApi from 'api/home/deal-mangement';
import deviceSeriesApi from 'api/home/device-mangement/device-series';
import DealChoose from '../DealChose';
import DealDetail from '../DealDetail';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  components: {
    DealChoose,
    DealDetail
  },
  props: {
    code: {
      type: Object,
      default: () => {}
    },
    orgId: {
      default: ''
    },
    value: {
      type: Object
    },
    deviceCategoryId: {
      default: ''
    },
    sysNo: {
      default: ''
    }
  },
  data() {
    return {
      timeOut: null,
      deviceBrandList: [],
      seriesList: [],
      versionList: [],
      agreementList: [],
      historyAgreementList: [],
      parameterList: [],
      commonForm: {}
    };
  },
  inject: ['isDetail'],
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.commonForm = newVal;
      }
    },
    commonForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    },
    sysNo: {
      immediate: true,
      handler: function (newVal) {
        this.$nextTick(() => {
          this.commonForm.uniqueNumber = newVal;
        });
      }
    },
    deviceCategoryId: {
      deep: true,
      immediate: true,
      handler: function (newVal) {
        if (newVal) {
          this.getDeviceBrandList();
        }
      }
    }
  },
  computed: {
    commonRules() {
      return {
        uniqueNumber: [
          { required: !this.isDetail(), message: '系统唯一标识不能为空', trigger: 'blur' }
        ],
        deviceBrand: [{ required: !this.isDetail(), message: '请选择设备品牌', trigger: 'change' }],
        // agreement: [{ required: !this.isDetail(), message: '请选择关联协议', trigger: 'change' }],
        deviceSeries: [{ required: !this.isDetail(), message: '请选择设备系列', trigger: 'change' }]
      };
    }
  },
  methods: {
    reset() {
      this.$refs.commonForm.resetFields();
      this.deviceBrandList = [];
      this.versionList = [];
      this.seriesList = [];
      this.commonForm.versionChoosed = {};
      this.agreementList = [];
      this.historyAgreementList = [];
    },
    clear() {
      this.$nextTick(() => {
        this.$refs.commonForm.clearValidate();
      });
    },
    change() {
      this.commonForm = {
        versionChoosed: {},
        uniqueNumber: this.commonForm.uniqueNumber,
        deviceBrand: '',
        agreement: [],
        deviceSeries: '',
        parameter: []
      };
      this.versionList = [];
      this.deviceBrandList = [];
      this.agreementList = [];
      this.seriesList = [];
      this.historyAgreementList = [];
      this.clear();
    },
    filter(arr) {
      return filter(this.parameterList, item => arr.includes(item.id))
        .map(item => item.name)
        .join('、');
    },
    // 设备品牌下拉
    getDeviceBrandList() {
      deviceBrandApi.getDeviceBrandByType({ categoryId: this.deviceCategoryId }).then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        if (!data.length) {
          !this.isDetail() && this.$message.warning('该设备类型下暂无设备品牌');
        }
        this.deviceBrandList = data.map(item => {
          return {
            id: item.id,
            brandName: item.typeName
          };
        });
      });
    },
    brandChange(val) {
      if (val) {
        this.getDealList(val);
        this.getSeriesList(val);
        this.commonForm.agreement = [];
        this.commonForm.versionChoosed = {};
        this.commonForm.deviceSeries = '';
        this.$nextTick(() => {
          this.$refs.commonForm.clearValidate(['deviceSeries']);
        });
      }
    },
    seriesChange(val) {
      if (val) {
        this.getParameterList(val);
        this.commonForm.parameter = [];
      }
    },
    getParameterList(id) {
      deviceParameterApi.getDeviceParameterBySeries({ id }).then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        if (!data.length) {
          !this.isDetail() && this.$message.warning('该设备系列下暂无功能参数');
        }
        this.parameterList = data.map(item => {
          return {
            id: item.id,
            name: item.functionName
          };
        });
      });
    },
    // 设备系列下拉
    getSeriesList(id) {
      deviceSeriesApi.getDeviceSeriesByBrand({ deviceTypeId: id }).then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        if (!data.length) {
          !this.isDetail() && this.$message.warning('该设备品牌下暂无设备系列');
        }
        this.seriesList = data.map(item => {
          return {
            id: item.id,
            name: item.seriesName
          };
        });
      });
    },
    // 获取品牌下的协议
    getDealList(id) {
      dealApi.getAllDealList({ deviceTypeId: id }).then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        if (!data.length) {
          !this.isDetail() && this.$message.warning('该设备品牌下暂无关联协议');
        }
        this.agreementList = data.map(item => {
          return {
            id: item.id,
            agreementName: item.protocolName,
            protocolVersionResultList: item.protocolVersionResultList
          };
        });
      });
    },
    getVersionList(id) {
      return dealApi.getDealDetail({ id: id });
    },
    validate() {
      let type;
      this.$refs.commonForm.validate(validated => {
        type = validated;
      });
      return type;
    },
    getData() {
      let deviceProtocolPortList = [];
      if (!isEmpty(this.commonForm.versionChoosed)) {
        for (const key in this.commonForm.versionChoosed) {
          const obj = cloneDeep(this.commonForm.versionChoosed[key]);
          const { id, serverPortId } = obj;
          deviceProtocolPortList.push({
            serverPortId,
            protocolVersionId: id
          });
        }
      }
      let data = {
        deviceTypeId: this.commonForm.deviceBrand,
        deviceTypeName: find(this.deviceBrandList, item => item.id == this.commonForm.deviceBrand)
          ? find(this.deviceBrandList, item => item.id == this.commonForm.deviceBrand).brandName
          : '',
        deviceSeriesName: find(this.seriesList, item => item.id == this.commonForm.deviceSeries)
          ? find(this.seriesList, item => item.id == this.commonForm.deviceSeries).name
          : '',
        deviceSeriesId: this.commonForm.deviceSeries,
        deviceFunctionList: this.commonForm.parameter,
        deviceProtocolPortList
      };
      if (!(this.code.type == 3 || this.code.type == 4 || this.code.type == 5)) {
        data.uniqueNumber = this.commonForm.uniqueNumber;
      }
      return data;
    },
    setData(data) {
      const {
        deviceFunctionList,
        deviceProtocolPortList,
        deviceSeriesId,
        deviceTypeId,
        uniqueNumber
      } = data;
      if (deviceSeriesId) {
        this.getParameterList(deviceSeriesId);
      }
      this.getSeriesList(deviceTypeId);
      this.getDealList(deviceTypeId);
      this.$nextTick(() => {
        if (uniqueNumber) {
          this.commonForm.uniqueNumber = uniqueNumber;
        } else {
          this.commonForm.uniqueNumber = this.sysNo;
        }
        this.commonForm.parameter = deviceFunctionList.map(item => {
          return item.id;
        });
        this.commonForm.agreement = deviceProtocolPortList.map(item => {
          this.commonForm.versionChoosed[item.id] = {
            id: item.protocolVersionId,
            name: item.protocolVersion,
            serverPortId: item.serverPortId
          };
          return item.id;
        });
        this.historyAgreementList = deviceProtocolPortList.map(item => {
          return { id: item.id, agreementName: item.protocolName };
        });
        this.commonForm.deviceBrand = deviceTypeId;
        this.commonForm.deviceSeries = deviceSeriesId || '';
      });
    },
    agreementChange(item) {
      const { id } = item;
      if (!this.isChoosed(id)) {
        this.agreementChose(item);
      } else {
        const index = this.commonForm.agreement.indexOf(id);
        this.commonForm.agreement.splice(index, 1);
        delete this.commonForm.versionChoosed[id];
      }
    },
    async agreementChose(item) {
      const { id, protocolVersionResultList } = item;
      this.versionList = cloneDeep(protocolVersionResultList);
      if (this.versionList.length > 1) {
        this.$refs.dealChoose.init(id);
        return;
      }
      const {
        data: { data, code }
      } = await this.getGoodServeDetail(this.versionList[0].id);
      if (data.protocolVersionServerPortResultList.length === 0) {
        this.$message.warning('暂无法选择该协议');
        return;
      }
      const obj = {
        id: this.versionList[0].id,
        name: this.versionList[0].protocolVersion,
        serverPortId: data.protocolVersionServerPortResultList[0].id
      };
      this.chooseAgreement(id, obj);
    },
    versionChooseBack(falg, data) {
      if (!falg) {
        return;
      }
      const { id, version } = data;
      this.chooseAgreement(id, version);
    },
    chooseAgreement(id, data) {
      this.commonForm.agreement.push(id);
      this.commonForm.versionChoosed[id] = {
        ...data
      };
    },
    //协议是否选中
    isChoosed(id) {
      return this.commonForm.agreement.includes(id);
    },
    getGoodServeDetail(id) {
      return dealApi.getGoodServerAndPortByVersionId({
        protocolVersionId: id
      });
    },
    seeServeDetail(id) {
      const protocolVersionServerPortId = this.commonForm.versionChoosed[id].serverPortId;
      this.$refs.dealDetail.init(protocolVersionServerPortId);
    }
  }
};
</script>
<style lang="less" scoped>
.agreement-box {
  font-size: 14px;
  margin-right: 10px;
  &:last-of-type {
    margin-left: 0;
  }
}
</style>